import { createSlice } from "@reduxjs/toolkit";
import { RootState } from "../../index";

export interface ISnackbarProps {
	open: boolean;
	message: string;
	vertical?: "top" | "bottom";
	horizontal?: "right" | "left" | "center";
}
interface notificationsState {
	snackBar: ISnackbarProps;
}

const initialState: notificationsState = {
	snackBar: {
		open: false,
		vertical: "bottom",
		horizontal: "right",
		message: ""
	}
};

const notificationSlice = createSlice({
	name: "notifications",
	initialState,
	reducers: {
		configSnackbar: (state, action) => {
			state.snackBar = { ...state.snackBar, ...action.payload };
		}
	},
	extraReducers: builder => {}
});

export const { configSnackbar } = notificationSlice.actions;
export const getFullNotificationsState = (state: RootState): notificationsState => state.notifications;
export default notificationSlice.reducer;
